<script lang="ts">
      import BlockWidth from '../blocks/BlockWidth.svelte'
      import LexicalRender from './LexicalRender.svelte'

      $effect(() => {
            if (block.lexical?.root) {
                  root = block.lexical.root
            }
      })

      let { block } = $props()

      let root = $state({})
      //console.log('lexical block')
</script>

<div class=" text-black flex flex-col items-center p-2">
      <BlockWidth>
            <LexicalRender {root}></LexicalRender>
      </BlockWidth>
</div>

<style lang="postcss">
</style>
